export default {
  mounted() {
    this.el.addEventListener("click", () => {
      const url = this.el.dataset.url
      navigator.clipboard.writeText(url).then(() => {
        const orig = this.el.innerText
        this.el.innerText = "Copied!"
        setTimeout(() => { this.el.innerText = orig }, 2000)
        if (window.jitsu) {
          window.jitsu("track", "share.link_copied", {
            content_type: this.el.dataset.shareType || "unknown",
            share_id: this.el.dataset.shareId || ""
          })
        }
      })
    })
  }
}
